import { HttpClient } from "@angular/common/http";
import { IResult } from "app/common/interfaces";
import { AbstractService } from "app/services/abstract.service";
import { environment as env } from "../../../../../../environments/environment.prod";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import EmailAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/common/embedded/email/email.entity";
import { ICreateSalesOfficeEmail } from "../interfaces/create-sales-office-email.interface";
import { IUpdateSalesOfficeEmail } from "../interfaces/update-sales-office-email.interface";
const apiUrl = env.API_CONFIGURATION_URL;
const moduleName = "sales_office_email";

@Injectable({
  providedIn: "root",
})
export class SalesOfficeEmailService extends AbstractService<
  EmailAttributes,
  ICreateSalesOfficeEmail,
  IUpdateSalesOfficeEmail
> {
  constructor(http: HttpClient) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findBySalesOfficeId(
    salesOfficeId: string
  ): Observable<IResult<EmailAttributes>> {
    const API_URL: string = `${apiUrl}api/${moduleName}/${salesOfficeId}`;
    return this.http.get<IResult<EmailAttributes>>(API_URL);
  }
}
